import * as React from "react";

const AutosizeColumns = (props: any) => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <g fillRule="nonzero">
      <path d="M21 12l-4.886-4.857v3.643h-2.443V3.5H12.45v17h1.221v-7.286h2.443v3.643zM9.329 3.5v7.286H6.886V7.143L2 12l4.886 4.858v-3.644h2.443V20.5h1.221v-17z" />
    </g>
  </svg>
);

export default AutosizeColumns;

